import { useRef, useEffect } from 'react';
import styled from 'styled-components';

export default function GenderSelectBox(props) {
  const { gender, setGender } = props;

  const MaleButtonRef = useRef();
  const MaleTextRef = useRef();
  const FemaleButtonRef = useRef();
  const FemaleTextRef = useRef();

  useEffect(() => {
    if (gender === 'male') {
      MaleButtonRef.current.style.backgroundColor = `#FF8B48`;
      MaleButtonRef.current.style.border = `1px solid #FF8B48`;
      MaleTextRef.current.style.color = `#FFFFFF`;
      FemaleButtonRef.current.style.backgroundColor = `#FFFFFF`;
      FemaleButtonRef.current.style.border = `1px solid #B2B2B2`;
      FemaleTextRef.current.style.color = `#595959`;
    }
    else if (gender === 'female') {
      MaleButtonRef.current.style.backgroundColor = `#FFFFFF`;
      MaleButtonRef.current.style.border = `1px solid #B2B2B2`;
      MaleTextRef.current.style.color = `#595959`;
      FemaleButtonRef.current.style.backgroundColor = `#FF8B48`;
      FemaleButtonRef.current.style.border = `1px solid #FF8B48`;
      FemaleTextRef.current.style.color = `#FFFFFF`;
    }
  }, [gender])

  return(
    <TopLevelWrapper>
      <Button ref={MaleButtonRef} onClick={() => setGender('male')}>
        <ButtonText ref={MaleTextRef}>남성</ButtonText>
      </Button>
      <Button ref={FemaleButtonRef} onClick={() => setGender('female')}>
        <ButtonText ref={FemaleTextRef}>여성</ButtonText>
      </Button>
    </TopLevelWrapper>
  )
}

const TopLevelWrapper = styled.div`
  display: flex;
  flex-direcion: row;

  justify-content: center;
  align-items: center;

  gap: 4px;
`;

const Button = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 60px;
  height: 30px;

  border: 1px solid #B2B2B2;
  border-radius: 5px;

  background-color: #FFFFFF;

  transition: all 0.3s ease-in-out;

  &:hover {
    cursor: pointer;
  }
`;

const ButtonText = styled.p`
  font-family: NotoSansKR-Regular;
  font-size: 14px;

  color: #000000;

  margin: 0 0 0 0;
  
  transition: all 0.3s ease-in-out;
`;